<template>
  <div class="flex gap-2 sm:gap-4 text-sm">
    <ul class="flex-1 list-none text-heroblue font-semibold grid grid-cols-1 gap-1.5 sm:gap-2.5 overflow-y-auto scrollbar-light pr-2 -mr-2">
      <li
        v-for="quarter in quarters"
        class="cursor-pointer px-3 flex-center transition-colors rounded border border-gray-200 leading-none"
        :class="[
          {'bg-heroblue text-white': quarter === selection.quarter},
          {'hover:bg-black/5 border-gray-300': quarter !== selection.quarter}
        ]"
        @click="setQuarter(quarter)"
      >
        <span>{{quarter}}</span>
      </li>
    </ul>

    <u-divider orientation="vertical" :ui="{border: {base: 'dark:border-gray-200'}}" />

    <ul class="list-none text-charcoal grid grid-cols-1 gap-1.5 sm:gap-2.5 overflow-y-auto max-h-48 relative text-center scrollbar-light pr-2 -mr-2" ref="yearPickerEl">
      <li
        v-for="year in years"
        class="cursor-pointer flex-center px-8 py-3 transition-colors border border-gray-200 leading-none"
        :class="[
          {'bg-heroblue text-white font-semibold': year === selection.year},
          {'hover:bg-black/5 border-gray-300': year !== selection.year}
        ]"
        @click="setYear(year)"
        :data-year-value="year"
      >
        {{year}}
      </li>
    </ul>
  </div>
</template>

<script setup>
  const props = defineProps({
    yearRange: {
      type: Array
    }
  });

  const dayJs = useDayjs();
  const dateRange = defineModel();
  const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
  const years = Array.from(Array((props.yearRange[1] - props.yearRange[0]) + 1), (n, i) => props.yearRange[1] - i);
  const selection = computed({
    get() {
      const theDate = dateRange.value?.val ? dayJs(dateRange.value?.val[0]) : dayJs();

      return {
        quarter: quarters[Math.floor(theDate.utc().month() / 3)],
        year: theDate.utc().year()
      }
    },
    set({quarter, year}) {
      const quarterIndex = quarters.findIndex(q => q === quarter);
      const startMonth = quarterIndex * 3;
      const endMonth = startMonth + 2;

      dateRange.value.val = [
        dayJs().utc().year(year).month(startMonth).startOf('month'),
        dayJs().utc().year(year).month(endMonth).endOf('month')
      ];
    }
  });

  function setQuarter(quarter) {
    selection.value = {
      quarter,
      year: selection.value.year
    };
  }

  function setYear(year) {
    selection.value = {
      quarter: selection.value.quarter,
      year
    };
  }

  const yearPickerEl = ref();

  onMounted(() => {
    //note: needed to update the dateRange model to the appropriate range
    selection.value = {
      quarter: selection.value.quarter,
      year: selection.value.year
    };

    // Scroll to the selected year
    scrollSelectedItemToTop(yearPickerEl.value, `[data-year-value="${selection.value.year}"]`);

  });

</script>
